export const mapEmployeeToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
    department: item.department?.name,
    role: item.roles[0]?.name,
  }));

  return result;
};
export const employeeColumns = [
  { key: "fullName", label: "Name", align: "center" },
  { key: "email", label: "Email", align: "center" },
  { key: "phone", label: "Phone", align: "center" },
  { key: "department", label: "Department", align: "center" },
  { key: "role", label: "Role", align: "center" },
  { key: "address", label: "Address", align: "center" },
];
